import * as MuseumCollectionEffects from './museum-collections.effect';

export const effects = { ...MuseumCollectionEffects };
